var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AdminView',[_c('h1',{staticClass:"title-1"},[_vm._v("Succès")]),_c('AchievementsForm',{attrs:{"achievements":_vm.achievements}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }